import HomeMain from "../Components/HomeMain";
import HomeFooter from "../Components/HomeFooter";

function Home() {
  const marqueeItems = [
    "Tablet Press",
    "Roll Compactor",
    "Quality Manufacturing",
    "cGMP Compliance",
    "Precision Engineering",
    "After Sales Support",
    "Made in India",
  ];

  const services = [
    {
      icon: "fas fa-tablets",
      title: "HIGH SPEED DOUBLE SIDE ROTARY TABLET PRESS",
      desc: "Advanced tablet compression machines designed for pharmaceutical manufacturing with precision control, cGMP compliance, and high-speed production capabilities for various tablet shapes and sizes.",
      image: "assets/images/SD PHRMA BG JPGS/4.png",
    },
    {
      icon: "fas fa-industry",
      title: "Single Side Rotary Tablet Press (GMP)",
      desc: "Reliable single rotary tablet press machines offering efficient tablet production with superior quality control, ideal for small to medium batch pharmaceutical manufacturing operations.",
      image: "assets/images/SD PHRMA BG JPGS/8.png",
    },
    {
      icon: "fas fa-compress",
      title: "Double Side Rotary Tableting Machine",
      desc: "State-of-the-art roll compaction equipment for dry granulation processes, delivering consistent particle size and density for pharmaceutical formulations without requiring liquid binders.",
      image: "assets/images/SD PHRMA BG JPGS/8.png",
    },
    {
      icon: "fas fa-cogs",
      title: "Mini Rotary Tablet Press",
      desc: "Comprehensive pharmaceutical manufacturing solutions including tablet press, coating machines, granulators, multi mill, fluid bed dryer, and dust extraction systems for turnkey production facilities.",
      image: "/assets/images/SD PHRMA BG JPGS/14.png",
    },
  ];
 

  const projects = [
    {
      title: "TabletFluid Bed Dryer (FBD)",
      category: "Pharmaceutical Equipment",
      image: "assets/images/SD PHRMA BG JPGS/2.png",
    },
    {
      title: "Double Rotary Tablet Press TAB-2000",
      category: "HIGH SPEED DOUBLE SIDE ROTARY TABLET PRESS",
      image: "assets/images/SD PHRMA BG JPGS/4.png",
    },
    {
      title: "De-Burring & De-Dusting Machine",
      category: "Pharmaceutical Equipment",
      image: "assets/images/SD PHRMA BG JPGS/26.png",
    },
    {
      title: "Roll Compactor RC-100",
      category: "Double Side Rotary Tableting Machine",
      image: "assets/images/SD PHRMA BG JPGS/8.png",
    },
  ];

  const testimonials = {
    left: [
      {
        rating: 100,
        text: '"Working with Bexon has been a game-changer business. Their team\'s profession alism, attention to detail, and innovative solutions have help streamline operations our goals faster than imagined. We truly feel like a valued partner."',
        author: "Nathaniel Ellington",
        designation: "Chief Executive",
        style: "",
      },
      {
        rating: 100,
        text: '"Working with Bexon has been a game-changer business. Their team\'s profession alism, attention to detail, and innovative solutions have help streamline operations our goals faster than imagined. We truly feel like a valued partner."',
        author: "Nathaniel Ellington",
        designation: "Chief Executive",
        style: "style-2",
      },
    ],
    right: [
      {
        rating: 100,
        text: '"S.D. Pharma Machine provides excellent pharmaceutical equipment. Their tablet press machines are reliable, efficient, and meet all cGMP standards. The after-sales support is outstanding and their team is always ready to help."',
        author: "Pharmaceutical Manufacturer",
        designation: "Production Head",
        style: "style-2",
      },
      {
        rating: 100,
        text: '"We have been using S.D. Pharma Machine equipment for years. The quality of their roll compactors and tablet press machines is exceptional. Their installation and training services made the setup process seamless."',
        author: "Generic Drug Company",
        designation: "Plant Manager",
        style: "",
      },
    ],
  };

  const clients = [
    "assets/images/brands/brand-1-light.webp",
    "assets/images/brands/brand-2-light.webp",
    "assets/images/brands/brand-3-light.webp",
    "assets/images/brands/brand-4-light.webp",
    "assets/images/brands/brand-5-light.webp",
    "assets/images/brands/brand-6-light.webp",
  ];

  const blogs = [
    {
      image: "assets/images/blog/h5-blog-1.webp",
      date: "15",
      month: "Nov",
      category: "Machinery",
      author: "S.D. Pharma",
      title:
        "Advanced Tablet Press Technology for Modern Pharmaceutical Manufacturing",
      delay: ".3s",
      animation: "fadeInLeft",
    },
    {
      image: "assets/images/blog/h5-blog-2.webp",
      date: "10",
      month: "Nov",
      category: "Equipment",
      author: "S.D. Pharma",
      title:
        "Roll Compactor Systems: Dry Granulation Solutions for Pharma Industry",
      delay: ".4s",
      animation: "fadeInRight",
    },
    {
      image: "assets/images/blog/h5-blog-3.webp",
      date: "05",
      month: "Nov",
      category: "Quality",
      author: "S.D. Pharma",
      title: "cGMP Compliance in Pharmaceutical Manufacturing Equipment",
      delay: ".5s",
      animation: "fadeInRight",
    },
  ];

  return (
    <>
      {/* <HomeMain /> */}
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main id="primary" className="site-main">
            <div className="top-space-15"></div>

            {/* Banner Section */}
            <section className="h9-hero">
              <div className="h9-hero-inner">
                <div
                  className="h9-hero-bg-image"
                  style={{
                    backgroundImage: "url(assets/images/hero/h9-hero-bg.webp)",
                  }}
                ></div>
                <div className="h9-hero-item-wrapper">
                  <div className="h9-hero-content">
                    <h1 className="h9-hero-title text-anim">
                      Manufacturing <span className="wow fadeInLeft"></span>
                      Excellence in Pharmaceutical Machinery.
                    </h1>
                    <div className="h9-hero-desc-area">
                      <h4 className="title wow fadeInUp">
                        Precision Equipment for Quality Production.
                      </h4>
                      <div className="desc-inner wow fadeInUp">
                        <p className="desc">
                          Leading manufacturer of pharmaceutical machinery
                          including tablet press machines, roll compactors, and
                          complete production line equipment. All machines are{" "}
                          <a href="/services">cGMP compliant</a> with precision
                          engineering and dedicated after-sales support. Trusted
                          by 500+ pharmaceutical companies across India.
                        </p>
                        <a className="tj-primary-btn" href="/contact">
                          <span className="btn-text">
                            <span>Get Quote</span>
                          </span>
                          <span className="btn-icon">
                            <i className="tji-arrow-right-long"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                    <div className="h9-hero-social wow fadeInUp">
                      <div className="social-links style-3">
                        <ul>
                          <li>
                            <a
                              href="https://www.facebook.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa-brands fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.instagram.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa-brands fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://x.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa-brands fa-x-twitter"></i>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.linkedin.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa-brands fa-linkedin-in"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="h9-hero-img img-parallax wow fadeInUp">
                    <img src="assets/images/hero/h9-hero-img.webp" alt="" />
                  </div>
                </div>
              </div>
              <div className="h7-hero-shape h9-hero-shape-1 wow fadeInUpBig">
                <img
                  className="tj-anim-move-var-big"
                  src="assets/images/shape/h7-hero-blur-1.png"
                  alt=""
                />
              </div>
              <div className="h7-hero-shape h9-hero-shape-2 wow fadeInDownBig">
                <img
                  className="tj-anim-move-var-big-reverse"
                  src="assets/images/shape/h7-hero-blur-2.png"
                  alt=""
                />
              </div>
            </section>

            {/* Choose Section */}
            <section id="choose" className="tj-choose-section section-gap">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="sec-heading style-8 sec-heading-centered">
                      <span className="sub-title wow fadeInUp">
                        Why Choose Us
                      </span>
                      <h2 className="sec-title title-anim">
                        Leading Pharmaceutical Equipment Manufacturer.
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="row row-gap-4 rightSwipeWrap">
                  <div className="col-md-6 col-lg-4">
                    <div className="choose-box customers-box h9-choose-box right-swipe">
                      <h4 className="title">
                        Trusted by Leading Pharmaceutical Manufacturers.
                      </h4>
                      <div className="customers-inner">
                        <div className="customers">
                          <ul>
                            <li className="wow fadeInLeft">
                              <img
                                src="assets/images/testimonial/client-1.webp"
                                alt=""
                              />
                            </li>
                            <li className="wow fadeInLeft">
                              <img
                                src="assets/images/testimonial/client-2.webp"
                                alt=""
                              />
                            </li>
                            <li className="wow fadeInLeft">
                              <img
                                src="assets/images/testimonial/client-3.webp"
                                alt=""
                              />
                            </li>
                            <li className="wow fadeInLeft">
                              <img
                                src="assets/images/testimonial/client-4.webp"
                                alt=""
                              />
                            </li>
                          </ul>
                        </div>
                        <div className="rating-area">
                          <div className="star-ratings">
                            <div
                              className="fill-ratings"
                              style={{ width: "100%" }}
                            >
                              <span>★★★★★</span>
                            </div>
                            <div className="empty-ratings">
                              <span>★★★★★</span>
                            </div>
                          </div>
                        </div>
                        <h5 className="customers-text">
                          500+ satisfied clients.
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="choose-box h9-choose-box right-swipe">
                      <div className="choose-content">
                        <div className="choose-icon">
                          <i className="tji-award"></i>
                        </div>
                        <h4 className="title">
                          Quality Engineering Excellence
                        </h4>
                        <p className="desc">
                          Precision-engineered pharmaceutical equipment with
                          cGMP compliance. Our machines deliver consistent
                          performance with minimal downtime.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div
                      className="choose-box h9-choose-box h9-choose-bg right-swipe"
                      style={{
                        backgroundImage:
                          "url(assets/images/choose/h9-choose-bg.webp)",
                      }}
                    >
                      <div className="choose-content">
                        <h4 className="title">Comprehensive Support</h4>
                        <p className="desc">
                          Complete installation, training, and maintenance
                          services. Our expert technicians provide prompt
                          support with genuine spare parts availability.
                        </p>
                        <a className="text-btn" href="/contact">
                          <span className="btn-text">
                            <span>Contact Us</span>
                          </span>
                          <span className="btn-icon">
                            <i className="tji-arrow-right-long"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Marquee Area */}
            <section className="h5-maquee z-2">
              <div className="h5-maquee-inner">
                <div className="swiper h5-maquee-slider">
                  <div className="swiper-wrapper h5-maquee-slider-wrapper">
                    {[...marqueeItems, ...marqueeItems].map((item, index) => (
                      <div
                        key={index}
                        className="swiper-slide h5-maquee-slider-item"
                      >
                        <div className="marquee-box">
                          <div className="marquee-icon-wrapper">
                            <div className="marquee-icon">
                              <i className="tji-star"></i>
                            </div>
                          </div>
                          <div className="marquee-title">
                            <h4 className="title">{item}</h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div dir="rtl" className="h5-maquee-inner h5-maquee-inner-rtl">
                <div className="swiper h5-maquee-slider">
                  <div className="swiper-wrapper h5-maquee-slider-wrapper">
                    {[...marqueeItems, ...marqueeItems].map((item, index) => (
                      <div
                        key={index}
                        className="swiper-slide h5-maquee-slider-item"
                      >
                        <div className="marquee-box">
                          <div className="marquee-icon-wrapper">
                            <div className="marquee-icon">
                              <i className="tji-star"></i>
                            </div>
                          </div>
                          <div className="marquee-title">
                            <h4 className="title">{item}</h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* About Section */}
            <section className="section-bottom-gap">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="sec-heading style-8 h9-sec-heading text-start">
                      <span
                        className="sub-title wow fadeInUp"
                        data-wow-delay=".3s"
                      >
                        About S.D. Pharma Machine
                      </span>
                      <h2
                        className="sec-title title-highlight wow fadeInUp"
                        data-wow-delay=".3s"
                      >
                        Excellence in Manufacturing Pharmaceutical Machinery -
                        Driven by Precision Engineering, Innovation, and
                        Commitment to Quality Production Standards.
                      </h2>
                    </div>
                    <div className="h9-about-area">
                      <div
                        className="about-img-area h9-about-img wow fadeInLeft"
                        data-wow-delay=".3s"
                      >
                        <div className="about-img overflow-hidden">
                          <img
                            data-speed=".8"
                            src="assets/images/about/h9-about.webp"
                            alt=""
                          />
                        </div>
                        <div className="box-area">
                          <div
                            className="author-info wow fadeInUp"
                            data-wow-delay=".3s"
                          >
                            <h4 className="title">S.D. Pharma Machine</h4>
                            <span className="designation">
                              Manufacturing Excellence
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="h9-about-content">
                        <p className="desc wow fadeInUp" data-wow-delay=".4s">
                          S.D. Pharma Machine is a leading manufacturer of
                          pharmaceutical machinery in India, specializing in
                          tablet press machines, roll compactors, and complete
                          production line equipment. We are committed to
                          delivering precision-engineered machines that meet
                          cGMP standards and exceed customer expectations. Our
                          equipment is designed for reliability, efficiency, and
                          consistent performance in pharmaceutical manufacturing
                          operations.
                        </p>
                        <div
                          className="h9-about-funfact wow fadeInUp"
                          data-wow-delay=".6s"
                        >
                          <div className="countup-item">
                            <div className="inline-content">
                              <span
                                className="odometer countup-number"
                                data-count="500"
                              >
                                500
                              </span>
                              <span className="count-plus">+</span>
                            </div>
                            <span className="count-text">
                              Satisfied pharmaceutical companies trust our
                              equipment.
                            </span>
                          </div>
                          <div className="countup-item">
                            <div className="inline-content">
                              <span
                                className="odometer countup-number"
                                data-count="15"
                              >
                                15
                              </span>
                              <span className="count-plus">+</span>
                            </div>
                            <span className="count-text">
                              Years of manufacturing excellence and innovation.
                            </span>
                          </div>
                        </div>
                        <div
                          className="about-btn-area-2 wow fadeInUp"
                          data-wow-delay=".7s"
                        >
                          <a className="tj-primary-btn" href="/about">
                            <span className="btn-text">
                              <span>Learn More</span>
                            </span>
                            <span className="btn-icon">
                              <i className="tji-arrow-right-long"></i>
                            </span>
                          </a>
                          <a
                            className="video-btn video-popup"
                            data-autoplay="true"
                            data-vbtype="video"
                            data-maxwidth="1200px"
                            href="https://www.youtube.com/watch?v=MLpWrANjFbI"
                          >
                            <span className="play-btn">
                              <i className="tji-play"></i>
                            </span>
                            <span className="video-text">
                              View our facility
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Service Section */}
            <section className="h9-service section-gap section-gap-x tj-sticky-panel-container-2 tj-progress-wrapper">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-4">
                    <div className="sec-heading style-8 tj-sticky-panel-2">
                      <span
                        className="sub-title wow fadeInUp"
                        data-wow-delay=".3s"
                      >
                        OUR PRODUCTS
                      </span>
                      <h2 className="sec-title title-anim">
                        Pharmaceutical Equipment Range
                      </h2>
                      <div
                        className="h9-service-more wow fadeInUp"
                        data-wow-delay=".3s"
                      >
                        <a className="tj-primary-btn" href="/services">
                          <span className="btn-text">
                            <span>View All Products</span>
                          </span>
                          <span className="btn-icon">
                            <i className="tji-arrow-right-long"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-8">
                    <div className="h9-service-scroll-progress tj-scroll-progress tj-sticky-panel-2">
                      {[1, 2, 3, 4].map((num, index) => (
                        <div
                          key={num}
                          className={`tj-scroll-progress-item ${
                            index === 0 ? "active" : ""
                          }`}
                        >
                          <h5 className="tj-scroll-progress-sln">0{num}.</h5>
                          <div className="tj-scroll-progress-ind">
                            <div className="tj-scroll-progress-ind-inner"></div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="service-wrapper h9-service-wrapper">
                      {services.map((service, index) => (
                        <div
                          key={index}
                          className="service-item style-5 tj-progress-item"
                        >
                          <div className="service-content-area">
                            <div className="service-icon">
                              <i className={service.icon}></i>
                            </div>
                            <div className="service-content">
                              <h4 className="title">
                                <a href="service-details.html">
                                  {service.title}
                                </a>
                              </h4>
                              <p className="desc">{service.desc}</p>
                            </div>
                            <a
                              href="service-details.html"
                              className="h9-service-nav"
                            >
                              <i className="tji-arrow-right-long"></i>
                            </a>
                          </div>
                          <div className="service-img">
                            <img src={service.image} alt="" />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-shape-1">
                <img src="assets/images/shape/pattern-2.svg" alt="" />
              </div>
              <div className="bg-shape-2">
                <img src="assets/images/shape/pattern-3.svg" alt="" />
              </div>
              <div className="bg-shape-3">
                <img
                  src="./assets/images/shape/h7-testimonial-shape-blur.svg"
                  alt=""
                />
              </div>
            </section>
            <div className="top-space-15"></div>
            <div className="top-space-15"></div>
            <div className="top-space-15"></div>
            {/* Project Section */}
            <section className="tj-project-section-3 h9-project section-gap section-gap-x">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="sec-heading-wrap">
                      <div className="heading-wrap-content">
                        <div className="sec-heading style-8">
                          <span
                            className="sub-title wow fadeInUp"
                            data-wow-delay=".3s"
                          >
                            OUR PORTFOLIO
                          </span>
                          <h2 className="sec-title title-anim">
                            Empowering Business with Expertise.
                          </h2>
                        </div>
                        <div
                          className="slider-navigation d-none d-md-inline-flex wow fadeInUp"
                          data-wow-delay=".5s"
                        >
                          <div className="slider-prev">
                            <span className="anim-icon">
                              <i className="tji-arrow-left"></i>
                              <i className="tji-arrow-left"></i>
                            </span>
                          </div>
                          <div className="slider-next">
                            <span className="anim-icon">
                              <i className="tji-arrow-right"></i>
                              <i className="tji-arrow-right"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div
                      className="project-wrapper h9-project-wrapper wow fadeInUp"
                      data-wow-delay=".4s"
                    >
                      <div className="swiper h9-project-slider">
                        <div className="swiper-wrapper">
                          {projects.map((project, index) => (
                            <div key={index} className="swiper-slide">
                              <div className="project-item">
                                <div className="project-img">
                                  <img src={project.image} alt="" />
                                </div>
                                <div className="project-content">
                                  <span className="categories">
                                    <a href="#">{project.category}</a>
                                  </span>
                                  <div className="project-text">
                                    <h4 className="title">
                                      <a href="#">{project.title}</a>
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="swiper-pagination-area"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-shape-1">
                <img src="assets/images/shape/pattern-2.svg" alt="" />
              </div>
              <div className="bg-shape-2">
                <img src="assets/images/shape/pattern-3.svg" alt="" />
              </div>
            </section>

            {/* Testimonial Section */}
            <section className="h9-testimonial section-gap">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4 order-2 order-lg-1">
                    <div className="h9-testimonial-wrap">
                      {testimonials.left.map((testimonial, index) => (
                        <div
                          key={index}
                          className={`testimonial-item ${testimonial.style} wow fadeInUpBig`}
                          data-wow-delay={index === 0 ? ".2s" : ".4s"}
                        >
                          <div className="star-ratings">
                            <div
                              className="fill-ratings"
                              style={{ width: `${testimonial.rating}%` }}
                            >
                              <span>★★★★★</span>
                            </div>
                            <div className="empty-ratings">
                              <span>★★★★★</span>
                            </div>
                          </div>
                          <div className="desc">
                            <p>{testimonial.text}</p>
                          </div>
                          <div className="testimonial-author">
                            <div className="author-inner">
                              <div className="author-header">
                                <h5 className="title">{testimonial.author}</h5>
                                <span className="designation">
                                  {testimonial.designation}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-lg-4 order-1 order-lg-2">
                    <div className="h9-testimonial-heading">
                      <div className="sec-heading style-8">
                        <span
                          className="sub-title wow fadeInUp"
                          data-wow-delay=".3s"
                        >
                          Clients Testimonials
                        </span>
                        <h2 className="sec-title title-anim">
                          Our Trusted Clients.
                        </h2>
                      </div>
                      <div
                        className="testimonial-img wow fadeInUpBig"
                        data-wow-delay=".3s"
                      >
                        <img
                          src="assets/images/testimonial/h9-testimonial-img.webp"
                          alt=""
                        />
                      </div>
                      <div
                        className="shape-icon wow fadeIn"
                        data-wow-delay=".5s"
                      >
                        <img src="assets/images/shape/big-icon.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 order-3 order-lg-3">
                    <div className="h9-testimonial-wrap style-2">
                      {testimonials.right.map((testimonial, index) => (
                        <div
                          key={index}
                          className={`testimonial-item ${testimonial.style} wow fadeInUpBig`}
                          data-wow-delay={index === 0 ? ".2s" : ".4s"}
                        >
                          <div className="star-ratings">
                            <div
                              className="fill-ratings"
                              style={{ width: `${testimonial.rating}%` }}
                            >
                              <span>★★★★★</span>
                            </div>
                            <div className="empty-ratings">
                              <span>★★★★★</span>
                            </div>
                          </div>
                          <div className="desc">
                            <p>{testimonial.text}</p>
                          </div>
                          <div className="testimonial-author">
                            <div className="author-inner">
                              <div className="author-header">
                                <h5 className="title">{testimonial.author}</h5>
                                <span className="designation">
                                  {testimonial.designation}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="tj-client-section-2 h6-client section-gap-x wow fadeInUp"
              data-wow-delay=".4s"
            >
              <div className="container-fluid client-container">
                <div className="row">
                  <div className="col-12">
                    <div className="h6-client-title-wrapper">
                      <h6 className="h6-client-title">
                        we're proud to partner with best-in-class clients
                      </h6>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="swiper client-slider client-slider-2 h6-client-slider">
                      <div className="swiper-wrapper">
                        {clients.map((client, index) => (
                          <div key={index} className="swiper-slide client-item">
                            <div className="client-logo">
                              <img src={client} alt="" />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Blog Section */}
            <section className="h5-blog section-gap fix">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="sec-heading-wrap style-8">
                      <div className="heading-wrap-content">
                        <div className="sec-heading style-8">
                          <span
                            className="sub-title wow fadeInUp"
                            data-wow-delay=".3s"
                          >
                            Insights & Ideas
                          </span>
                          <h2 className="sec-title text-anim">
                            The Ultimate Resource.
                          </h2>
                        </div>
                        <div
                          className="btn-area wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <a className="tj-primary-btn" href="/blog">
                            <span className="btn-text">
                              <span>More Blogs</span>
                            </span>
                            <span className="btn-icon">
                              <i className="tji-arrow-right-long"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="h5-blog-wrapper h9-blog-wrapper">
                      {blogs.map((blog, index) => (
                        <div
                          key={index}
                          className={`blog-item style-2 h5-blog-item wow ${blog.animation}`}
                          data-wow-delay={blog.delay}
                        >
                          <div className="blog-thumb">
                            <a href="#">
                              <img src={blog.image} alt="" />
                            </a>
                            <div className="blog-date">
                              <span className="date">{blog.date}</span>
                              <span className="month">{blog.month}</span>
                            </div>
                          </div>
                          <div className="blog-content">
                            <div className="title-area">
                              <div className="blog-meta">
                                <span className="categories">
                                  <a href="#">{blog.category}</a>
                                </span>
                                <span>
                                  By <a href="#">{blog.author}</a>
                                </span>
                              </div>
                              <h4 className="title">
                                <a href="#">{blog.title}</a>
                              </h4>
                            </div>
                            <a className="text-btn" href="#">
                              <span className="btn-text">
                                <span>Read More</span>
                              </span>
                              <span className="btn-icon">
                                <i className="tji-arrow-right-long"></i>
                              </span>
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}

export default Home;
